<template>
  <PageLayout>
    <PageHeader :title="$t(`Common.title.homeTitle`)" />
    <div class="px-4">
      <EntryButton v-for="(entry, index) in entries" :key="index" :hasIcon="false" :label="entry.name"
        @click="onClick(entry)"></EntryButton>
    </div>
  </PageLayout>
</template>

<script>
import PageLayout from "@/components/PageLayout.vue";
import PageHeader from 'common/components/Layout/web/PageHeader.vue';
import EntryButton from 'common/components/Layout/web/EntryButton.vue';

export default {
  name: 'Home',
  components: {
    PageLayout,
    PageHeader,
    EntryButton,
  },
  data() {
    return {
      entries: [
        {
          name: this.$t(`Common.title.search2`),
          path: '/rule/search',
        },

        {
          name: this.$t(`Common.title.pay`),
          path: '/rule/pay',
        },
      ],
    };
  },
  methods: {
    onClick(entry) {
      this.$router.push(entry.path);
    },
  },
};
</script>
